module.exports = __webpack_public_path__ + "static/img/sprite2310.6382e4b.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/sprite2310.png
// module id = KAp+
// module chunks = 7